import {
  ApiNoteInProgress,
  usePostByTenantNoteAndNoteIdInstructionApproveSettlementMutation,
  usePostByTenantNoteAndNoteIdInstructionRejectMutation
} from 'api/rtk-api'
import clsx from 'clsx'
import { ConfirmUsernameField, LinkButton } from 'components/core-v2'
import Icon from 'components/core-v2/atoms/Icon'
import IconButton from 'components/core-v2/molecules/iconButton'
import { intersection } from 'lodash'
import { FormProvider, useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { formatCurrencyFull } from 'utilities/currency'
import { useUser } from 'utilities/hooks/useUser'

import { CURRENCY, TENANT } from '../../../const'
import { useOnSuccess } from '../utilities/useOnSuccess'
import classes from './activation-tab.module.scss'
import { WaitingOnRoleAlert } from './waiting-on-role-alert'

const AUTHORISED_ROLES = ['Administrator', 'Operations']
interface Props {
  inProgressNote: ApiNoteInProgress
}
export const SettlementTab = ({ inProgressNote }: Props) => {
  const { data: user } = useUser()
  const { noteId } = useParams()
  const form = useForm()

  const onSuccess = useOnSuccess()

  const [submitApproval, { isLoading }] =
    usePostByTenantNoteAndNoteIdInstructionApproveSettlementMutation()
  const [submitRejection] = usePostByTenantNoteAndNoteIdInstructionRejectMutation()

  if (!user) return null

  const isCurrentStage = inProgressNote.noteStatus === 'PendingSettlement'
  const canUserCompleteStep = intersection(user.roles, AUTHORISED_ROLES).length > 0
  const isInteractive = isCurrentStage && canUserCompleteStep

  const onSubmit = async () => {
    const response = await submitApproval({
      tenant: TENANT,
      noteId
    })
    // Success
    if ('data' in response) {
      onSuccess()
    }
  }

  return (
    <FormProvider {...form}>
      {!canUserCompleteStep && isCurrentStage && <WaitingOnRoleAlert />}
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className={clsx(classes.tradeWrapper, classes.tradeWrapperPadding)}>
          <p>Check the account has been settled</p>
          <span className={classes.amount}>
            {formatCurrencyFull(inProgressNote.instructionAmount, CURRENCY)}
          </span>
        </div>
        {isInteractive && (
          <>
            <ConfirmUsernameField
              id="usernameConfirmation"
              label="To approve the settlement, enter your username below and click on the button"
            />
            <div className={classes.buttonWrapper}>
              <IconButton
                icon={<Icon name="check" size="small" />}
                iconPosition="left"
                isLoading={isLoading}
                operationType="progress"
                text="Approve"
                type="submit"
              />
              <LinkButton type="button" onClick={() => submitRejection({ tenant: TENANT, noteId })}>
                Reject
              </LinkButton>
            </div>
          </>
        )}
      </form>
    </FormProvider>
  )
}
